import React, { useState, useEffect, useContext } from "react";
import Header from '../header/Header'
import ReactPlayer from 'react-player'

import AWS from 'aws-sdk'
import * as constants from "../../config/config"
import { Spinner } from "react-bootstrap";
import { resetSaveMediaFilesDetails, saveAudioAndVideoFiles } from "../../redux/features/audioAndVideoFiles/audioAndVideoSlice";
import AppContext from "../../storage/AppContext";
import { useDispatch, useSelector } from "react-redux";
import useToast from "../../shared/Toast";

const s3 = new AWS.S3({
    accessKeyId: constants.awsAccessKey,
    secretAccessKey: constants.awsSecretKey
});

const SaveMediaFiles = () => {
    const [url, setUrl] = useState('');
    const [name, setName] = useState('');
    const [type, setType] = useState('');
    const [mediaData, setMediaData] = useState('');
    const [loading, setLoading] = useState(false)

    const saveMediaFilesDetails = useSelector(state => state.audioAndVideo.saveMediaFilesDetails)

    const dispatch = useDispatch();
    const showToast = useToast();

    const appContext = useContext(AppContext);
    const userDetails = appContext?.userDetails

    const resetState = () => {
        setUrl('')
        setName('')
        setType('')
        setMediaData('')
    }

    useEffect(() => {
        if(saveMediaFilesDetails.status === 'succeeded'){
            // setTimeout(() => {
            //     window.location.reload()
            // }, 2500)
            showToast({ message: saveMediaFilesDetails.message })
            dispatch(resetSaveMediaFilesDetails())
            resetState()
        }
        if(saveMediaFilesDetails.status === "failed"){
            showToast({message: saveMediaFilesDetails.message, type: 'error'})
        }
    },[saveMediaFilesDetails])

    const onChangeAudio = async (e) => {
        const name = e.target.files[0].name;
        const data = e.target.files[0]
        const contentType = e.target.files[0].type
        const url =  URL.createObjectURL(e.target.files[0])

        setUrl(url)
        setName(name)
        setType(contentType)
        setMediaData(data)
    }

    console.log("audio url",url,name,type, mediaData)
    
    const fileUpload = async (file) => {
        // setLoading(true)
        const formData = new FormData();
        formData.append("file", file);
        formData.append("platform", 'svbk/dev');
        const url = 'https://upload.aauti.com/file/Upload';
        const response = await fetch(url, {
          method: "POST",
          body: formData,
        });
        let responseJson = await response.json();
        // setLoading(false)
        return responseJson?.result;
      };

    const onClickSave = async () => {
        setLoading(true)
        const link = await fileUpload(mediaData)
        setLoading(false)
        dispatch(saveAudioAndVideoFiles({url:link,name,type,branch: userDetails?.data?.branch}))
    }
    return (
        <>
        <Header />
        {(saveMediaFilesDetails.status === 'loading' || loading) ? 
        <div style={{ minHeight: '80vh' }} className='d-flex justify-content-center align-items-center'>
            <Spinner animation="border" role="status"></Spinner>
        </div>
        :
        <>
        <div>
            <div className="mt-2 ml-2">
                <input
                    className="inputfile"
                    type="file"
                    id="file"
                    onChange={onChangeAudio}
                    accept="video/*,audio/*"
                />
                <label htmlFor="file">Upload Audio/Video</label>
            </div>
           {url &&
            <div className="px-3 d-flex flex-column ">
                <div className="mt-2 mb-2">
                    <h5>Name of the file : {name}</h5>
                </div>
                {type.includes('audio') ? <audio controls><source src={url} type={type} /></audio> : <ReactPlayer url={url} controls={true} />}
                <button className="btn btn-primary align-self-start mt-2" onClick={onClickSave}>Save</button>
            </div>
            }
        </div>
        </>}
      </>
    );
}

export default SaveMediaFiles
